<template>
  <tr>
    <td>{{name}} <Tooltip :label="helpTip" v-if="helpTip"><i class="far fa-info-circle text-muted"></i></Tooltip></td>
    <td><slot /></td>
  </tr>
</template>


<script>
export default {
  name: 'PropertyValueRow',
  props: {
    name: String,
    helpTip: String
  }
}
</script>